import {createEffectFn} from '@ngneat/effects';
import {catchError, debounceTime, distinctUntilChanged, EMPTY, Observable, switchMap} from 'rxjs';
import {usersService} from '@store/settings/users/users.service';
import {UsersState} from '@store/settings/users/users.store';

type SearchUserParams = Partial<UsersState>

export const searchUsersEffect = createEffectFn((params$: Observable<SearchUserParams>) => {
  return params$.pipe(
    debounceTime(300),
    distinctUntilChanged(),
    switchMap(() => usersService.getUsers().pipe(catchError(() => EMPTY))),
  );
});
